window.validator = {
  //* *********************************************
  // Validation based on http://jqueryvalidation.org/validate/.
  // Simply add basic validation rules to the markup.
  // Developer: GHammar
  //* *********************************************
  initialize(formElement, formRules, formMessages, formErrorPlacement, hideErrors) {
    let showErrors = null;

    formMessages = formMessages || {};
    formRules = formRules || {};

    // if hide errors is set then set showErrors to blank function
    if (hideErrors) {
      showErrors = function () {};
    } else {
      showErrors = Utils.showErrors;
    }

    this.form = formElement;
    this.validateInstance = this.form.validate({
      submitHandler() {},
      onsubmit() { return false; },
      showErrors,
      unhighlight(element) {
        $(element).removeClass('error').parents('.control-group').removeClass('error');
      },
      ignore: 'input[type=hidden]',
      rules: formRules,
      messages: formMessages,
      errorPlacement: formErrorPlacement,
    });

    return this.validateInstance;
  },
  // Call this function to validate the form. Usually, call this before submitting to server.
  isValid() {
    if (this.emailRequired && this.$emailField.val() === '') {
      this.addError(this.$emailField, window.lookup('Please enter an email'));
      return false;
    }

    if (this.loginRequired && this.$loginField.val() === '') {
      this.addError(this.$loginField, window.lookup('Please enter a username'));
      return false;
    }
    return this.form.valid();
  },
  // Call this function test the form is valid without triggering error events
  testValid() {
    return this.validateInstance.checkForm();
  },
};
